import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { MapTool } from '~/_shared/types/toolsAndFeatures/mapTools.types';
import { useTranslation } from '~/_shared/utils/hooks';
import { usePlacesHelpers } from '~/places/usePlacesHelpers';
import { openMapTool } from '~/store/frontendState/leftSidebar/leftSidebar.actionCreators';
import { mapSettingsPlacesRemoveSearch } from '~/store/mapSettings/places/mapSettingsPlaces.actionCreators';
import { useMapSettingsPlacesSearchesSelector } from '~/store/mapSettings/places/mapSettingsPlaces.selectors';
import {
  toolStateHidePlaceSearch, toolStateShowPlaceSearch,
} from '~/store/mapSettings/toolsState/visibility/visibility.actionCreators';
import { useHiddenPlaceSearchIdsSelector } from '~/store/mapSettings/toolsState/visibility/visibility.selectors';
import { createMapStatusBarItemFromPlaceSearch } from '../item/mapStatusBarItem.factory';
import type { MapStatusBarItem } from '../mapStatusBarItem.type';

export const usePlacesStatusBarItems = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const placesSearches = useMapSettingsPlacesSearchesSelector();
  const hiddenPlaceSearchIds = useHiddenPlaceSearchIdsSelector();
  const { zoomToPlacesSearchArea } = usePlacesHelpers();

  return useMemo<MapStatusBarItem[]>(() => {
    return placesSearches.map(placesSearch => {
      return createMapStatusBarItemFromPlaceSearch({
        isVisible: !hiddenPlaceSearchIds.includes(placesSearch.id),
        search: placesSearch,
        t,
        onRemove: () => dispatch(mapSettingsPlacesRemoveSearch(placesSearch)),
        onClick: () => {
          zoomToPlacesSearchArea(placesSearch.id);
          dispatch(openMapTool(MapTool.Places));
        },
        onVisibilityChange: (isVisible: boolean) => {
          if (isVisible) {
            dispatch(toolStateShowPlaceSearch(placesSearch.id));
          }
          else {
            dispatch(toolStateHidePlaceSearch(placesSearch.id));
          }
        },
      });
    });
  }, [placesSearches, hiddenPlaceSearchIds, t, dispatch, zoomToPlacesSearchArea]);
};
